import React from 'react';
import './EventPost.css';

function EventPost({ title, description, date, onClick }) {
  const truncateDescription = (desc) => {
    return desc.length > 100 ? `${desc.substring(0, 100)}...` : desc;
  };

  const eventDate = date ? new Date(date).toLocaleString('pl-PL', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }) : 'Brak ustalonej daty.';

  return (
    <div className="event-post" onClick={onClick}>
      <div className="event-info">
        <h3 className="event-title">{title}</h3>
        <p className="event-date">{eventDate}</p>
        <p className="event-description">{truncateDescription(description)}</p>
      </div>
    </div>
  );
}


export default EventPost;
